import TextStyle from '@tiptap/extension-text-style';

declare module '@tiptap/core' {
  interface Commands<ReturnType> {
    textAlign: {
      /**
       * Set the text alignment
       */
      setTextAlign: (align: 'left' | 'center' | 'right' | 'justify') => ReturnType;
      /**
       * Unset the text alignment
       */
      unsetTextAlign: () => ReturnType;
    };
  }
}

export const TextAlignExtended = TextStyle.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      textAlign: {
        default: null,
        parseHTML: element => element.style?.textAlign || null,
        renderHTML: attributes => {
          if (!attributes.textAlign) {
            return {};
          }
          return {
            style: `text-align: ${attributes.textAlign}; display: inline-block; width: 100%;`,
          };
        },
      },
    };
  },

  addCommands() {
    return {
      ...this.parent?.(),
      setTextAlign:
        (textAlign: 'left' | 'center' | 'right' | 'justify') =>
        ({ chain }) => {
          return chain().setMark(this.name, { textAlign }).run();
        },
      unsetTextAlign:
        () =>
        ({ chain }) => {
          return chain().setMark(this.name, { textAlign: null }).removeEmptyTextStyle().run();
        },
    };
  },
});

export default TextAlignExtended;
